import store from '../../store'

export default async (to, from, next) => {
  if (store.getters['auth/isAuth']) {
    return next({
      name: 'dashboard',
    });
  }

  next()
}



// WEBPACK FOOTER //
// ./src/router/middleware/onlyGuest.js